"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const crud_client_1 = require("./crud.client");
class ApiKeysClient extends crud_client_1.CrudClient {
    constructor() {
        super(...arguments);
        this.entityPath = 'api-keys';
    }
    create() {
        throw new Error('ApiKeysClient(create): please call add method');
    }
    add(projectId, apiKey) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpPost(this.getPath(projectId), apiKey);
            return response.payload;
        });
    }
    revoke(projectId, id, credentials) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpPost(`${this.getPath(projectId, id)}/revoke`, credentials);
            return response.payload;
        });
    }
    regenerate(projectId, id, key) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpPost(`${this.getPath(projectId, id)}/regenerate`, key);
            return response.payload;
        });
    }
    getCalls(parameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const { projectId, id } = parameters;
            const response = yield this.httpGet(this.getPath(projectId, `${id}/calls`, Object.assign(Object.assign({}, parameters), { projectId: undefined, id: undefined })));
            return response.payload;
        });
    }
    update(parameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const { projectId, id } = parameters;
            yield this.httpPut(this.getPath(projectId, `${id}`), Object.assign(Object.assign({}, parameters), { projectId: undefined, id: undefined }));
        });
    }
}
exports.ApiKeysClient = ApiKeysClient;
//# sourceMappingURL=api-keys.client.js.map